@if (formGroup) {
  <form [formGroup]="formGroup" [class.mb-3]="has_mb3" [class.my-3]="has_my3" #multiselect>
    <dk-label [label]="label" [isRequired]="required" [disabled]="disabled || control?.disabled" />
    <p-multiSelect
      [formControlName]="controlName"
      [placeholder]="placeholder | translate"
      [options]="options"
      [id]="id"
      [dataKey]="dataKey"
      [optionValue]="optionValue"
      [optionLabel]="optionLabel"
      [filter]="filter"
      [group]="group"
      [loading]="loading"
      [disabled]="disabled"
      [class.disabled]="disabled"
      [virtualScroll]="virtualScroll"
      [virtualScrollItemSize]="virtualScrollItemSize"
      [emptyMessage]="emptyMessage"
      [selectedItemsLabel]="'{0} ' + (selectedItemsLabel | translate)"
      [appendTo]="appendTo"
      [emptyFilterMessage]="emptyFilterMessage"
      [scrollHeight]="screenHight > 900 ? scrollHeight : '150px'"
      [class.is-valid]="!control?.invalid && control?.touched"
      [class.is-invalid]="control?.invalid && control?.touched"
      (onChange)="onChange.emit($event)"
      (onSelectAllChange)="onSelectAllChange.emit($event.checked)">
      <ng-template let-group pTemplate="group">
        <div class="flex align-items-center">
          <img
            *ngIf="imageBaseSrc + group[imageKey] + imageExtension as optionImageSrc"
            [src]="optionImageSrc"
            width="22px"
            height="15px"
            style="border-radius: 3px" />
          @if (translatePrefix) {
            <div>{{ translatePrefix + '.' + group.label | translate }}</div>
          } @else {
            <div>{{ group.label }}</div>
          }
        </div>
      </ng-template>
      <ng-template let-value pTemplate="selectedItems">
        <div class="d-flex align-items-center gap-1 dk-option-label">
          @if (value?.length > maxSelectedLabels) {
            <div>{{ value.length + ' ' + ('primeng.itemsSelected' | translate) }}</div>
          } @else {
            @if (value?.length > 0) {
              @for (selectedOption of value; track selectedOption; let i = $index) {
                <img
                  *ngIf="imageBaseSrc + selectedOption[imageKey] + imageExtension as optionImageSrc"
                  [src]="optionImageSrc"
                  width="22px"
                  height="15px"
                  style="border-radius: 3px" />
                @if (translatePrefix) {
                  <div>
                    {{ translatePrefix + '.' + selectedOption[optionLabel] | translate }}
                    @if (i < value.length - 1) {
                      <span>,</span>
                    }
                  </div>
                } @else {
                  <div>
                    {{ selectedOption[optionLabel] }}
                    @if (i < value.length - 1) {
                      <span>,</span>
                    }
                  </div>
                }
              }
            }
          }
        </div>
        <div *ngIf="!value || value.length === 0">{{ placeholder | translate }}</div>
      </ng-template>

      <ng-template let-option pTemplate="item">
        <span class="d-flex align-items-center gap-1 dk-option-label">
          <img
            *ngIf="imageBaseSrc + option[imageKey] + imageExtension as optionImageSrc"
            [src]="optionImageSrc"
            width="22px"
            height="15px"
            style="border-radius: 3px" />
          @if (translatePrefix) {
            <div>{{ translatePrefix + '.' + option[optionLabel] | translate }}</div>
          } @else {
            <div>{{ option[optionLabel] }}</div>
          }
        </span>
      </ng-template>
    </p-multiSelect>
    <dk-field-validation-error-message [control]="control" />
  </form>
} @else {
  <div [class.mb-3]="has_mb3" [class.my-3]="has_my3">
    <dk-label [label]="label" [isRequired]="required" [disabled]="disabled" />
    <p-multiSelect
      [(ngModel)]="ngModelValue"
      [placeholder]="placeholder | translate"
      [group]="group"
      [options]="options"
      [id]="id"
      [optionLabel]="optionLabel"
      [optionValue]="optionValue"
      [filter]="filter"
      [loading]="loading"
      [class.disabled]="disabled"
      [disabled]="disabled"
      [emptyMessage]="emptyMessage"
      [selectedItemsLabel]="'{0} ' + (selectedItemsLabel | translate)"
      [virtualScroll]="virtualScroll"
      [virtualScrollItemSize]="virtualScrollItemSize"
      [emptyFilterMessage]="emptyFilterMessage"
      [virtualScrollItemSize]="virtualScrollItemSize"
      [scrollHeight]="screenHight > 900 ? scrollHeight : '150px'"
      (onChange)="onChange.emit($event)"
      (onSelectAllChange)="onSelectAllChange.emit($event.checked)"
      [appendTo]="appendTo">
      <!-- <ng-template let-group pTemplate="group">
        <div class="flex align-items-center">
          <img
            *ngIf="imageBaseSrc + group[imageKey] + imageExtension as optionImageSrc"
            [src]="optionImageSrc"
            width="22px"
            height="15px"
            style="border-radius: 3px" />
          <span>{{ group.label }} </span>
        </div>
      </ng-template>
      <ng-template let-value pTemplate="selectedItems">
        <div class="d-flex align-items-center gap-1 px-1 dk-option-label">
          @if (value?.length > maxSelectedLabels) {
            <div>{{ value.length + ' ' + ('primeng.itemsSelected' | translate) }}</div>
          } @else {
            @if (value?.length > 0) {
              @for (selectedOption of value; track selectedOption; let i = $index) {
                <img
                  *ngIf="imageBaseSrc + selectedOption[imageKey] + imageExtension as optionImageSrc"
                  [src]="optionImageSrc"
                  width="22px"
                  height="15px"
                  style="border-radius: 3px" />
                @if (translatePrefix) {
                  <div>
                    {{ translatePrefix + '.' + selectedOption[optionLabel] | translate }}
                    @if (i < value.length - 1) {
                      <span>,</span>
                    }
                  </div>
                } @else {
                  <div>{{ selectedOption[optionLabel] }}</div>
                  @if (i < value.length - 1) {
                    <span>,</span>
                  }
                }
              }
            }
          }
        </div>
        <div *ngIf="!value || value.length === 0">{{ placeholder | translate }}</div>
      </ng-template>
      <ng-template let-option pTemplate="item">
        <span class="d-flex align-items-center gap-1 px-1 dk-option-label">
          <img
            *ngIf="imageBaseSrc + option[imageKey] + imageExtension as optionImageSrc"
            [src]="optionImageSrc"
            width="22px"
            height="15px"
            style="border-radius: 3px" />
          @if (translatePrefix) {
            <div>{{ translatePrefix + '.' + option[optionLabel] | translate }}</div>
          } @else {
            <div>{{ option[optionLabel] }}</div>
          }
        </span>
      </ng-template> -->
    </p-multiSelect>
  </div>
}
